import { Component } from '@angular/core';

@Component({
  selector: 'mprd-skeleton-mobile-level-two',
  templateUrl: './skeleton-mobile-level-two.component.html',
})
export class SkeletonMobileLevelTwoComponent {
  constructor() {}
}
